<template>
  <memlist-modal size="lg" ref="support-popup" @hide="on_hide">


    <div class="d-flex flex-column">
      <div class="w-100 h-100 align-items-center text-center flex-wrap justify-content-center">
        <i class="fa fa-question-circle" style="font-size: 42px; color: #085f88;"></i>
      </div>


      <hr />

      <div>
        <div>

          <div class="w-100 align-items-center text-center justify-content-center">

            <h4 class="header-name mt-8" style="text-align: center; flex: 1;">{{ header }}</h4>
            <br />
            <p class="mt-8">{{ description }}</p>

          </div>
        </div>
      </div>
    </div>
  </memlist-modal>
</template>
    
<style lang="scss" scoped></style>
    
<script>

import axios from 'axios';

export default {
  name: 'InfoPopup',

  data() {
    return {

    };
  },
  props: ['header','description'],
  async mounted() {

  },
  watch: {

  },
  methods: {

    on_hide() {

    },


    show() {
      this.$refs['support-popup'].show();
    },
    onOk() {
      this.$refs['support-popup'].hide();
    },

    
  },
  computed: {

  }
};
</script>
    